import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Public Terms of Service page.
 */
const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4">
        <h1 className="text-3xl font-extrabold text-[#333] md:text-4xl">
          {t("Terms of Service")}
        </h1>
        <div className="mt-6 space-y-4 leading-relaxed text-gray-600">
          <p>
            {t("Please read these terms carefully before using the Uninfo HK platform.")}
          </p>
          <p>
            {t("By creating an account or using our services, you agree to these terms.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;